let timeoutSync = (ob, time) => { // 定时器，同步版
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            ob() || ob
            resolve(true)
        }, time);
    })
}
export {
    timeoutSync
}